import React, { useContext } from 'react';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import classNames from 'classnames';
import { DaylightContext } from '../../../../../DaylightCodeMapper';
import './styles.css';

const DisableMappingButton = ({ code, isUpdating }) => {
    const dispatch = useDispatch();
    const { practiceId, partnerId } = useContext(DaylightContext);

    const disableMapping = () => {
        dispatch(
            actions.daylight.markCodeAsDisabled(practiceId, code, partnerId)
        );
    };

    return (
        <FontAwesomeIcon
            className={classNames('mr-2 disable-mapping pop-hoverable', {
                rotating: isUpdating,
            })}
            icon={faBan}
            onClick={() => {
                if (!isUpdating) {
                    disableMapping();
                }
            }}
            size="lg"
            title="Add Disable Mapping"
        />
    );
};

export default DisableMappingButton;
